import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { deletePlanEndpoint } from 'services/plansEndPoints';
import { IPlanDetails } from 'interfaces/plan.interface';

export const deletePlan = createAsyncThunk('deletePlan', async (id: string) => {
  try {
    const endpoint = deletePlanEndpoint(id);
    return await apiFetch<Partial<IPlanDetails>>(endpoint).then((res) => res?.data || null);
  } catch (error) {
    let message = 'Something went wrong!';
    if (error instanceof Error) message = error.message;
    else {
      if (typeof error === 'object' && error !== null) {
        if ('message' in error) {
          message = String(error.message);
        }
      }
    }
    throw Error(message);
  }
});
